import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';

export default {
  fetchHotNow() {
    Dispatcher.dispatch({
      actionType: ActionTypes.HOME_STORE_FETCH_HOT_NOW,
    });
  },
  fetchToComplete() {
    Dispatcher.dispatch({
      actionType: ActionTypes.HOME_STORE_FETCH_TO_COMPLETE,
    });
  },
  fetchNeverSeen() {
    Dispatcher.dispatch({
      actionType: ActionTypes.HOME_STORE_FETCH_NEVER_SEEN,
    });
  },
  openTermModal(selectedTerms) {
    Dispatcher.dispatch({
      actionType: ActionTypes.HOME_STORE_SET_SELECTED_TERMS,
      selectedTerms
    })
  }
}
